import React from "react";
import { useState } from "react";
import { createPrefferPartner } from "../../api/PrefferPartner";
import Swal from "sweetalert2";

const CreatePrefferPartner = ({ onSuccess }) => {
  const [prefferPartner, setPrefferPartner] = useState({
    partner_name: "",
  });
  // state for image upload
  const [file, setFile] = useState(null);
  const handleFileChange = (e) => setFile(e.target.files[0]);
  const handleChange = (e) => {
    setPrefferPartner({
      ...prefferPartner,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("image", file);
    Object.entries(prefferPartner).forEach(([key, value]) =>
      formData.append(key, value)
    );
    const response = createPrefferPartner(formData);
    response
      .then((res) => {
        if (res.status === 200) {
          Swal.fire({
            title: "Hotel Created!",
            text: "You have successfully created a hotel!",
            icon: "success",
            draggable: true,
            timer: 1000,
          });
          onSuccess(res);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <>
      <form className="text-left" onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="exampleInputPartnerName">Partner Name</label>
          <input
            type="text"
            className="form-control"
            name="partner_name"
            onChange={handleChange}
          />
        </div>
        <div className="form-group">
          <label htmlFor="exampleInputImage">Image</label>
          <input
            type="file"
            className="form-control"
            name="image"
            onChange={handleFileChange}
          />
        </div>
        <button type="submit" className="btn btn-primary text-right">
          Save
        </button>
      </form>
    </>
  );
};

export default CreatePrefferPartner;
